export default __webpack_public_path__ + "static/media/suggestion.545b813e.svg";